import throttle from 'lodash/throttle';
import { useCallback } from 'react';

import { NOOP } from '../utils/noop';

export const useOnClickThrottled = (onClick = NOOP) =>
  // biome-ignore lint/correctness/useExhaustiveDependencies: reason
  useCallback(
    // If we pass null or undefined to throttle, this will cause an exception
    throttle(onClick, 500, { trailing: false }),
    [onClick],
  );
